import { useState, useMemo, useRef } from "react"
import { useRequest } from "ahooks";
import { Card, Button, message } from "antd";
import { Table, DEFAULT_PAGE_DATA } from "../../../components/table";
import { generateTableColumns } from "./config";
import { CardServer } from "../../../server";
import { langCommon, langPage } from "../../../locales";
import { Operation } from "./operation";

const server = CardServer.Product
const lang = langPage?.card;

export const CardProduct = () => {
    const operationRef: any = useRef();

    const [loading, setLoading] = useState<boolean>(false);
    const [tableData, setTableData] = useState<any[]>([]);
    const [pageData, setPageData] = useState<any>({ ...DEFAULT_PAGE_DATA });

    //获取表格数据
    const { run, refresh } = useRequest(server.list, {
        defaultParams: [{ ...pageData }],
        onBefore: () => setLoading(true),
        onFinally: () => setLoading(false),
        onError: () => {
            setTableData([]);
            setPageData({ ...pageData, Total: 0 });
        },
        onSuccess: (res: any) => {
            const { Total, List, Page, PageSize } = res;
            setTableData(List);
            setPageData({ Page, PageSize, Total });
        }
    });

    const { run: asyncCard } = useRequest(server.refresh, {
        manual: true,
        onBefore: () => setLoading(true),
        onFinally: () => setLoading(false),
        onError: () => {

        },
        onSuccess: () => {
            refresh();
            message.success(langCommon?.refreshSuccess)
        }
    });

    const getTableColumns = useMemo(() => {
        return generateTableColumns({ loading, setLoading, refresh, operationRef });
    }, [loading, setLoading, refresh, operationRef]);

    return (
        <div>
            <Card>
                <div className="flex flex-end mb20">
                    <Button loading={loading} className="ml10" type="primary" onClick={() => asyncCard()}>{lang?.product.async}</Button>
                </div>
                <Table
                    loading={loading}
                    dataSource={tableData}
                    columns={getTableColumns}
                    rowKey="Id"
                    scroll={{
                        x: 'max-content'
                    }}
                    page={pageData}
                    onPageChange={(Page: number, PageSize: number) => {
                        const currentPage = { ...pageData, Page, PageSize };
                        run({ ...currentPage });
                    }}
                />
            </Card>
            <Operation ref={operationRef} onSuccess={refresh} />
        </div>
    );
}